import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import './enq-product-list.component.scss';
import dayjs from 'dayjs';
import { getEnquiryById, getEnquiryProduct } from '../enquiry.services';
import { formatToNumber, isEmptyArray } from '../../common/util.services';
import { useNavigate, useParams } from 'react-router-dom';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import ProductDetailComponent from '../enq-product/product-detail.component';
import { IconButton, Stack } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

const EnquiryProductList = (props: any) => {
  const rows: GridRowsProp = [];
  const navigate = useNavigate();
  const [enqProduct, setEnqProduct] = useState(rows);
  const appContext = useContext(AppContext);
  const params = useParams();
  const enquiryId = params.enquiryId;
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, editable: false, sortable: false, width: 100 },
    { field: 'pack', headerName: 'Pc/Pack', filterable: false, editable: false, sortable: false, width: 90,
      valueFormatter: (value) => 0 === value ? 'NA' : value
    },
    { field: 'quantity', headerName: 'Quantity', filterable: false, editable: false, sortable: false, width: 95,
      valueFormatter: (value) => formatToNumber(value)
    },
    { field: 'uom', headerName: 'UOM', filterable: false, editable: false, sortable: false, width: 80 },
    { field: 'description', headerName: 'Description', filterable: false, editable: false, sortable: false, width: 130,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.id)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.description}</Stack>)
    },
    {
      field: 'costingTarget', headerName: 'Costing Target', filterable: false, editable: false, sortable: false, width: 120,
      valueFormatter: (costingTarget: any) => dayjs(costingTarget).format('DD-MMM-YYYY'),
    },
    { field: 'costingOwner', headerName: 'Cos Owner', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'costing', headerName: 'Costing', filterable: false, editable: false, sortable: false, width: 70,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openCostingPage(params.row) }}>{params.row.costing}</div> }
    },
    { field: 'costingStatus', headerName: 'Cos Status', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'order', headerName: 'Order', filterable: false, editable: false, sortable: false, width: 70,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openOrderPage(params.row) }}>{params.row.order}</div> }
    },
    { field: 'conversionStatus', headerName: 'Conv Status', filterable: false, editable: false, sortable: false, width: 120 },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, editable: false, sortable: false, width: 75 },
    { field: 'ageing', headerName: 'Ageing', filterable: false, editable: false, sortable: false, width: 60 },
    { field: 'productRemarks', headerName: 'Remarks', filterable: false, editable: false, sortable: false, width: 100},
  ];

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getEnquiryById(enquiryId, appContext,
        (response: any) => {
          setEnqProduct(response.data.product);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, []);

  const openCostingPage = (row: any) => {
    navigate('../costing-list/prd/' + row.id)
  }

  const openOrderPage = (row: any) => {
    navigate('../../product/' + row.id + '/order')
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={enqProduct} columns={columns} loading={loading} getRowId={(row: any) => row.id}
        showAction={false} showEditAction={false} showUpAction={false} hideFooterPagination={true} showAddBtn={false}
        showDeleteAction={false} showApproveAction={false} showAddAction={true} showDownAction={false}/>
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
              dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title='Products For Enquiry' panelBody={getMainPanel()} />
}

export default EnquiryProductList;
